import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Reveal";
import { AREAS } from "@/data/areas";

export const AreasStrip = () => (
  <section data-testid="areas-strip" className="bg-ink text-white py-24 sm:py-32 relative overflow-hidden">
    <div className="absolute inset-0 blueprint opacity-70" />
    <div className="container-x relative grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal><p className="eyebrow text-brass mb-5">Service areas</p></Reveal>
        <h2 className="font-wide font-black uppercase text-4xl sm:text-5xl leading-[0.95] tracking-tight">
          <MaskLines lines={["Plumbing across", "greater Sydney."]} />
        </h2>
        <Reveal delay={0.15}>
          <p className="mt-8 text-slate-300 leading-relaxed max-w-md">St George, the Sutherland Shire, Canterbury-Bankstown, the Inner West, the City and Eastern Suburbs, the North Shore, Western Sydney and Macarthur — {AREAS.length}+ suburbs and counting.</p>
          <Link to="/areas" data-testid="areas-strip-all" className="mt-8 inline-flex items-center gap-2 font-bold text-brass link-underline">See all service areas <ArrowUpRight className="h-4 w-4" /></Link>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-7 flex flex-wrap gap-2 content-start" delay={0.1}>
        {AREAS.filter((a) => a.feature).map((a) => (
          <Link key={a.slug} to={`/areas/${a.slug}`} data-testid={`area-chip-${a.slug}`}
            className="inline-flex items-center gap-2 h-12 px-5 rounded-full border border-white/20 text-sm font-semibold hover:bg-white hover:text-ink transition-colors">
            <MapPin className="h-4 w-4 text-brass" />{a.name}<span className="font-mono text-[11px] opacity-70">{a.postcode}</span>
          </Link>
        ))}
      </Reveal>
    </div>
  </section>
);
